
<div class="overlay-container" >
</div>
<div class="modal show" id="myModal"  [ngClass]="isPopupOpen?'show':'hide'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
     <div class="modal-body">
        <button type="button" class="close" (click)="close()">×</button>
        <div id="addorUpdat" class="mt-4 mb-4">Who will be picking this plate up?</div>
         <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
         {{errorMessage}}
        </div>
     <div class="row no-margin">
                    <div class="col-12 col-sm-12 mb-5">
                       <form autocomplete="off" class="text-left mb-5" [formGroup]="authorizedPersonForm">
        
                        <input type="text"  formControlName="name" class="form-control" id="name"  [ngClass]="{ 'is-invalid': submitted && f.name.errors }" placeholder="Name">  
                         <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">Please enter a name</div>
              </div>
                        </form>
                         </div>
                    
                    <div class="col-12 col-sm-12 mb-5">
                        <div>
                          <div id="firstName">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.pickupText}}</div>
             </div>                        
                    </div>                    

                    <div class="col-12 col-sm-12 mb-3"> 
                           <a>
                              <button class="btn btn-primary btn-commonbtn m-auto" (click)="submit()">Submit </button>
                            </a>  
                      </div>
                  </div>
     
     
     
     
      </div>

    </div>
  </div>
</div>